import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_PRODUTOS = "getProdutos";

// mutation types
export const SET_PRODUTOS = "setProdutos";

const state = {
  produtos: []
};

const getters = {
  produtos(state) {
    return state.produtos;
  }
};

const actions = {
  [GET_PRODUTOS](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get("produtosML").then(({ data }) => {
          context.commit(SET_PRODUTOS, data);
          resolve(data);
        });
      }
    });
  }
};

const mutations = {
  [SET_PRODUTOS](state, produtos) {
    state.produtos = produtos;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
